import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialTableViewState } from "./initializes";
import type { TableView, DynamicTableViewsType, RowHeightType } from "./types";

const tableViewSlice = createSlice({
  name: "TableView",
  initialState: initialTableViewState,
  reducers: {
    setViewErrorMessage: (state: TableView, action: PayloadAction<string>) => {
      state.viewErrorMessage = action.payload;
    },
    setIsViewEditMenu: (state: TableView, action: PayloadAction<boolean>) => {
      state.isViewEditMenu = action.payload;
    },
    setDynamicTableViewId: (state: TableView, action: PayloadAction<number | null>) => {
      state.dynamicTableViewId = action.payload;
    },
    setDynamicTableViews: (state: TableView, action: PayloadAction<DynamicTableViewsType>) => {
      state.dynamicTableViews = action.payload;
    },
    setRowHeight: (state: TableView, action: PayloadAction<RowHeightType>) => {
      state.rowHeight = action.payload;
    },
    setHidden: (state: TableView, action: PayloadAction<string[]>) => {
      state.hidden = action.payload;
    },
  },
});

export const {
  setViewErrorMessage,
  setIsViewEditMenu,
  setDynamicTableViewId,
  setDynamicTableViews,
  setRowHeight,
  setHidden,
} = tableViewSlice.actions;

export default tableViewSlice.reducer;
